
export default
	props:
		to: String
		label: String

